import { render, staticRenderFns } from "./kyc-certification-detail.vue?vue&type=template&id=b9caec04&"
import script from "./kyc-certification-detail.vue?vue&type=script&lang=js&"
export * from "./kyc-certification-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports